import { HandySvg } from "handy-svg";

const FreeTable = ({ children, styles, currency, isRu, dictionary }) => {
	return (
		<div className={`${styles.subscription_item} ${styles.free}`}>
			<div className={`${styles.top}`}>
				<h2 className={styles.title}>{dictionary["Free"] || "Free"}</h2>
			</div>

			<div className={styles.price}>{isRu ? 0 + currency.symbol : currency.symbol + 0}</div>
			<div className={`${styles.price_info} ${styles.free}`}>
				<span className={styles.span}>4 {dictionary["free_credits"]}</span>
				<div className={styles.freeFeatures}>
					<span className={styles.feature}>
						<HandySvg width="24" height="24" src={`/pricing/f_image.svg`} fill="transparent" />4 {dictionary["image_generation_edit"] || "image generation/edit"}
					</span>
					<span className={styles.separator}>{dictionary["or"] || "or"}</span>
					<span className={styles.feature}>
						<HandySvg width="24" height="24" src={`/pricing/f_video.svg`} fill="transparent" />
						{dictionary["bgremove_limitation_free"].replace("X", 5).replace("XX", 10)}
					</span>
					<span className={styles.separator}>{dictionary["or"] || "or"}</span>
					<span className={styles.feature}>
						<HandySvg width="24" height="24" src={`/pricing/f_infinity.svg`} fill="transparent" />
						{dictionary["or_around_x_minutes"]}
					</span>
				</div>
				{children}
			</div>
		</div>
	);
};

export default FreeTable;
